/**
 * What the paired Imperans answered to an onboarding submission (Epic 6303, Feature CRM1, story
 * 6339). Mirrors ImperansSubmissionOutcomeEnum on the server, value for value.
 */
export enum ImperansSubmissionOutcome {
  Pending = 1,
  Created = 2,
  Replayed = 3,
  AlreadyCreated = 4,
  Rejected = 5,
  Refused = 6,
  Failed = 7,
  TimedOut = 8,
  NotPaired = 9,
  KeptInCrmOnly = 10,
  /** The CRM's own self check failed on Submit: nothing was frozen or sent (story 6340). */
  SelfCheckFailed = 11,
}
